import compileSymbols from '~/utils/compileSymbols';

const types = ['ACTIVATE_INTERSECTING_ICON', 'DEACTIVATE_INTERSECTING_ICON'];

export default compileSymbols(types, 'iconButons');
